module.exports = __webpack_public_path__ + "img/app_img1.542aaf1a.png";